import { xhrFetch } from "../xhrManager";
import { dispatch } from "../Helpers/eventHelper";
import { isDomestic } from "../I18n/Market";
import { objectCopy } from "../Helpers/helpers";
import * as Sentry from "@sentry/browser";

export default () => ({
    data: {
        items: [],
        item_count: 0,
        total_price: 0,
    },
    lastFetchedCartData: {},
    loading: true,

    get isEmpty() {
        return this.data.item_count === 0;
    },

    get isEligibleForFreeShipping() {
        return this.data.total_price > 10000 && isDomestic();
    },

    init() {
        this.updateCartData();
    },

    freeze() {
        this.loading = true;
    },

    unfreeze() {
        this.loading = false;
    },

    setCartData(data) {
        this.lastFetchedCartData = objectCopy(data);
        this.data = data;
    },

    rollback() {
        this.data = objectCopy(this.lastFetchedCartData);
    },

    async updateCartData() {
        await xhrFetch(
            "/cart.js",
            {},
            (data) => {
                this.setCartData(data);
            },
            (error) => {
                console.error("Error loading Cart Data", error);
                Sentry.captureException(error);
            },
            () => {
                this.unfreeze();
            }
        );
    },

    async addToCart(data) {
        this.freeze();
        xhrFetch(
            "/cart/add.js",
            {
                method: "POST",
                body: JSON.stringify(data),
            },
            () => {},
            (exception) => {
                console.log(exception);
                Sentry.captureException(exception);
            },
            () => {
                this.updateCartData();
                dispatch("added-to-cart");
            }
        );
    },

    updateCartItem(item, quantity) {
        this.freeze();
        let payload = {
            quantity: quantity,
            id: item.key,
        };
        xhrFetch(
            "/cart/change.js",
            {
                method: "POST",
                body: JSON.stringify(payload),
            },
            (data) => {
                this.setCartData(data);
            },
            (exception) => {
                this.rollback();
                console.log(exception);
            },
            () => {
                this.unfreeze();
            }
        );
    },

    hasBoot() {
        return this.data.items.some((p) => p.product_type === "Boot" || p.product_type === "Shoe");
    },
});
